import { Fab } from "@mui/material";
import React from "react";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

interface FloatingButtonProps {
    onClick: () => void;
    icon?: React.ReactNode;
    color?: "primary" | "secondary" | "default" | "inherit" | "success" | "error" | "info" | "warning";
    position?: { bottom?: number; right?: number; left?: number; top?: number };
}

const FloatingButton: React.FC<FloatingButtonProps> = ({
    onClick,
    icon = <KeyboardArrowUpIcon />,
    color = "primary",
    position = { bottom: 16, right: 16 },
}) => {
    return (
        <Fab
            color={color}
            sx={{ position: "fixed", ...position } }
            onClick={onClick}
        >
            {icon}
        </Fab>
    );
};

export default FloatingButton;
